const actions = {
  LIST_EMPLEADO: 'LIST_EMPLEADO',
  CREATE_EMPLEADO: 'CREATE_EMPLEADO',
  READ_EMPLEADO: 'DREA_EMPLEADO',
  UPDATE_EMPLEADO: 'UPDATE_EMPLEADO',
  DELETE_EMPLEADO: 'DELETE_EMPLEADO',

  empleadoList: data => {  
    return {
      type: actions.LIST_EMPLEADO,
      data,
    };
  },

  empleadoCreate: data => {
    return {
      type: actions.CREATE_EMPLEADO,
      data,
    };
  },

  empleadoRead: data => {
    return {
      type: actions.READ_EMPLEADO,
      data,
    };
  },

  empleadoUpdate: data => {
    return {
      type: actions.UPDATE_EMPLEADO,
      data,
    };
  },

  empleadoDelete: () => {
    return {
      type: actions.DELETE_EMPLEADO,      
    };
  },


};

export default actions;
